<template>
    <div v-if="loadcarrierid" class="break-after delivery-note">
        <!-- <h1>DeliveryNote</h1> -->
        <!-- <hr> -->
        <b-row>
            <b-col cols="8">
                <img src="@/assets/img/brand/Sodexo_Logotype_Blue.png" alt="Sodexo Logo" class="img-fluid"
                    style="width: 250px;" />
            </b-col>
            <b-col style="text-align: right;">
                <img src="@/assets/img/brand/logivialogga_transp_min.png" alt="Transplanet Logo" class="img-fluid" />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <br /><br />
                <!-- <hr> -->
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12 text-center">
                <h1>Lastbärare </h1><br>
                <h1>{{ loadcarrierid }}</h1>
                <br/><br/><br/>        
            </b-col>
        </b-row>
        <b-row>
            <b-col style="text-align: center;" cols="12">
                <!-- <span class="libre-barcode-128-regular" style="font-size:55px">{{b.TspDocNo}}</span> -->
                <svg :ref="getBcRef(loadcarrierid)" :id="getBcRef(loadcarrierid)"></svg>
            </b-col>
        </b-row>
    </div>
</template>
<script>

import JsBarcode from 'jsbarcode';

export default {
    name: 'loadcarrierlabel',
    props: {
        loadcarrierid: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            b: null,

        };
    },
    watch: {
        loadcarrierid: function (newVal) {
            setTimeout(this.generateBarcode(this.loadcarrierid), 1);
        }
    },
    created() {

    },
    mounted() {
        setTimeout(this.generateBarcode(this.loadcarrierid), 1);

        // this.$nextTick(() => {
        //     this.generateBarcodes();
        // });
    },
    methods: {
        getBcRef(id) {
            return `barcode-${id}`;
        },
        generateBarcode(id) {
            if (id) {
                var elName = this.getBcRef(id);
                var r = this.$refs[elName];
                if (r)
                    JsBarcode(r, id, {
                        format: 'CODE128',
                        lineColor: '#000',
                        width: 6,
                        height: 300,
                        displayValue: true
                    });
            }
        }
    },
};

</script>
<style scoped>
.delivery-note {
    font-size: x-large;
    /* page-break-after: always; */
    padding: 10px;
    /* border: 1px solid black; */
    margin-bottom: 20px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    background-color: #fff;
}

.delivery-note-row {
    /* margin-bottom: 15px; */
    border-bottom: 0.5px solid #ccc;
}

.text-highlight {
    color: red;
    font-weight: bold;
}
</style>